/**
 * Collections Page - Clean Design
 * List all collections for schema management
 */

import { Link } from 'react-router-dom';
import { useAppStore } from '../stores';

export function Collections() {
    const { collections, currentApp } = useAppStore();

    return (
        <div className="animate-fade-in max-w-6xl mx-auto space-y-8">
            {/* Header */}
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div>
                    <h1 className="text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>
                        Collections
                    </h1>
                    <p style={{ color: 'var(--text-secondary)' }}>
                        Design and manage content structures for <span className="font-bold" style={{ color: 'var(--accent)' }}>{currentApp?.name}</span>
                    </p>
                </div>
                <Link to="/schema" className="btn btn-primary px-8">
                    + New Collection
                </Link>
            </div>

            {/* List */}
            {collections.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {collections.map((collection) => (
                        <Link
                            key={collection.id}
                            to={`/collections/${collection.id}`}
                            className="card p-6 transition-all hover:shadow-xl hover:-translate-y-1 group"
                        >
                            <div className="flex items-start gap-4">
                                <div
                                    className="w-14 h-14 rounded-2xl flex items-center justify-center text-3xl shrink-0"
                                    style={{ backgroundColor: 'var(--bg-secondary)' }}
                                >
                                    {collection.icon || '📄'}
                                </div>
                                <div className="flex-1 min-w-0">
                                    <h3
                                        className="text-lg font-bold truncate group-hover:text-blue-500 transition-colors"
                                        style={{ color: 'var(--text-primary)' }}
                                    >
                                        {collection.name}
                                    </h3>
                                    <p className="text-sm truncate mb-4" style={{ color: 'var(--text-muted)' }}>
                                        {collection.description || `/${collection.slug || collection.tableName}`}
                                    </p>

                                    <div className="flex items-center gap-3">
                                        <div className="px-2 py-1 rounded text-[10px] font-bold uppercase tracking-wider" style={{ backgroundColor: 'var(--bg-tertiary)', color: 'var(--text-muted)' }}>
                                            {collection.fields?.length || 0} Fields
                                        </div>
                                        <div className="px-2 py-1 rounded text-[10px] font-bold uppercase tracking-wider" style={{ backgroundColor: 'var(--bg-tertiary)', color: 'var(--text-muted)' }}>
                                            View Data →
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ))}

                    {/* Add New Slot */}
                    <Link
                        to="/schema"
                        className="card p-6 border-2 border-dashed flex flex-col items-center justify-center text-center group transition-all"
                        style={{ backgroundColor: 'transparent', borderColor: 'var(--border-color)' }}
                        onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--accent)'}
                        onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border-color)'}
                    >
                        <div className="text-3xl mb-2 group-hover:scale-125 transition-transform" style={{ color: 'var(--text-muted)' }}>+</div>
                        <span className="text-sm font-bold uppercase tracking-widest" style={{ color: 'var(--text-muted)' }}>Add New Collection</span>
                    </Link>
                </div>
            ) : (
                <div className="card p-16 text-center max-w-xl mx-auto">
                    <div className="text-6xl mb-6">📂</div>
                    <h3 className="text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                        No collections found
                    </h3>
                    <p className="mb-8" style={{ color: 'var(--text-secondary)' }}>
                        Collections are the blueprints for your content. Create one to start building your database.
                    </p>
                    <Link to="/schema" className="btn btn-primary px-10 py-3 font-bold shadow-lg shadow-blue-500/20">
                        Create Your First Collection
                    </Link>
                </div>
            )}
        </div>
    );
}
